<template>
    <div id="orderManagement">
        <div class="contentRight2">
            <div class="rightHead">
                <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">订单详情</div>
            </div>
            <div class="head" style="font-size:15px;color:#707070;height:90px;">
                <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>
                        <a
                            href="javascript:;"
                            v-if="type=='returnsPage'"
                            @click="hrefOrder('returnsAndRefunds')"
                        >退货退款</a>
                        <a href="javascript:;" v-else @click="hrefOrder('orderManagment')">订单管理</a>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item>订单详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="content" style="padding-top:0">
                <div class="table">
                    <div class="tableHead row">
                        <div>创建时间：{{commodityList.createTime}}</div>
                        <div>完成时间：{{commodityList.payTime}}</div>
                        <div>订单号：{{commodityList.tradeNo}}</div>
                        <div class="alignCenter">
                            <img style="margin-right:5px;" src="../../assets/icon/ggmd.png" alt />
                            {{commodityList.shopName}}
                        </div>

                        <div>钱如潮订单</div>
                    </div>
                    <div class="total row">
                        <div class="portion">
                            <div
                                style="font-size:20px;font-weight:600;"
                            >{{commodityList.orderStatus}}</div>
                            <!-- <div>订单超时未付款，自动关闭</div> -->
                        </div>
                        <div class="portion">
                            <div>付款信息</div>
                            <div>商品总价：{{commodityList.totalRetailPrice}}元</div>
                            <div>优惠金额：{{commodityList.totalDiscountPrice}}元</div>
                            <div>
                                支付方式：{{
                                commodityList.payInterfacePartyType == 0
                                ? "未知"
                                : commodityList.payInterfacePartyType == 1
                                ? "系统"
                                : commodityList.payInterfacePartyType == 2
                                ? "支付宝"
                                : commodityList.payInterfacePartyType == 3
                                ? "微信"
                                : commodityList.payInterfacePartyType == 11
                                ? "线下收款"
                                : commodityList.payInterfacePartyType == 12
                                ? "支付宝记账"
                                : commodityList.payInterfacePartyType == 13
                                ? "微信记账"
                                : commodityList.payInterfacePartyType == 8
                                ? "刷卡记账"
                                : commodityList.payInterfacePartyType == 10
                                ? "会员卡支付"
                                : ""
                                }}
                            </div>
                            <div
                                v-if="commodityList.shopPromotionData&&commodityList.shopPromotionData.length != 0"
                            >{{commodityList.shopPromotionData[0].name}}</div>
                            <div>实收金额：{{commodityList.gainMoney}}元</div>
                            <div
                                v-if="commodityList.orderStatus == '退款'||commodityList.orderStatus == '退款退货'"
                            >订单已退金额：{{commodityList.refundMoney}}元</div>
                            <!-- <div>商品数量：{{goodsList.totalCount}}件</div> -->
                        </div>
                        <div class="portion">
                            <div>收银员信息</div>
                            <div>收银员名称：{{commodityList.cashierUserFullName}}</div>
                            <div>收银员手机：{{commodityList.cashierUserPhoneNum}}</div>
                            <div>销售员名称：{{commodityList.saleFullName}}</div>
                            <div>销售员手机：{{commodityList.salePhoneNum}}</div>
                            <div>所属门店：{{commodityList.storeName}}</div>
                        </div>
                        <div class="portion">
                            <div>买家信息</div>
                            <div>买家：{{commodityList.buyerName}}</div>
                            <div>手机号码：{{commodityList.buyerPhone}}</div>
                            <div v-if="!commodityList.buyerCode">会员卡:无</div>
                            <div
                                v-else
                            >会员卡-NO.{{commodityList.buyerCode}}:{{commodityList.buyerCardName}}{{commodityList.buyerCardDiscount}}</div>
                        </div>
                    </div>
                </div>
                <div class="table tables" v-loading="loading" element-loading-text="拼命加载中">
                    <div class="tableHead2 row">
                        <div class="row toto">
                            <div
                                v-if="commodityList.orderStatus != '退款退货'"
                                style="width:38%;margin-left:40px;"
                            >商品</div>
                            <div v-if="commodityList.orderStatus != '退款退货'" style="width:14%">价格</div>
                            <div v-if="commodityList.orderStatus != '退款退货'" style="width:14%">数量</div>
                            <div v-if="commodityList.orderStatus != '退款退货'" style="width:14%">状态</div>

                            <div
                                v-if="commodityList.orderStatus == '退款退货'"
                                style="width:38%;margin-left:40px;"
                            >商品</div>
                            <div v-if="commodityList.orderStatus == '退款退货'" style="width:14%">单价</div>
                            <div v-if="commodityList.orderStatus == '退款退货'" style="width:14%">预计入库</div>
                            <div v-if="commodityList.orderStatus == '退款退货'" style="width:14%">良品入库</div>
                            <div
                                v-if="commodityList.orderStatus == '退款退货'"
                                style="width:14%"
                            >不良品报损出库量</div>
                        </div>
                        <div class="center" style="width: 12%">总价</div>
                        <div class="center" style="width: 12%;">状态</div>
                        <div class="center" style="width: 18%;">操作</div>
                    </div>
                    <div class="commodityList row">
                        <div class="commodity">
                            <div
                                v-for="(item,index1) in goodsList.list"
                                :key="index1"
                                class="commodityItem row alignCenter"
                            >
                                <div style="width:42%" class="row">
                                    <img
                                        v-if="item.goodsId"
                                        style="margin: 0 20px;"
                                        :src="item.goodsImage"
                                        alt
                                    />
                                    <img
                                        v-else
                                        style="margin: 0 20px;"
                                        src="../../assets/icon/wmsp.jpg"
                                        alt
                                    />
                                    <div class="column">
                                        <div>
                                            {{item.goodsName}}
                                            <span v-if="item.specDesc">({{item.specDesc}})</span>
                                        </div>
                                        <div
                                            style="color:gray;margin-top:10px"
                                            v-if="item.goodsBarCode"
                                        >商品条码：{{item.goodsBarCode}}</div>
                                        <div
                                            style="color:gray;margin-top:10px"
                                            v-if="!item.goodsBarCode"
                                        >商品条码：无</div>
                                    </div>
                                </div>

                                <div
                                    style="width:14%"
                                    v-if="commodityList.orderStatus != '退款退货'"
                                >￥{{item.turnoverPrice}}</div>
                                <div
                                    style="width:14%"
                                    v-if="commodityList.orderStatus != '退款退货'"
                                >{{item.qrcBuyCount}}{{item.goodsUnit}}</div>
                                <div
                                    style="width:14%"
                                    v-if="commodityList.orderStatus != '退款退货'"
                                >{{item.productSaleStatus==1?'退货退款':item.productSaleStatus==2?'正常':item.productSaleStatus==6?'仅退款':''}}</div>

                                <div
                                    v-if="commodityList.orderStatus == '退款退货'"
                                    style="width:14%"
                                >￥{{item.turnoverPrice}}</div>
                                <div
                                    v-if="commodityList.orderStatus == '退款退货'"
                                    style="width:14%"
                                >{{item.productSaleStatus ==1?item.refundCount:0}}</div>
                                <div
                                    v-if="commodityList.orderStatus == '退款退货'"
                                    style="width:14%"
                                >{{item.inputNum}}</div>
                                <div
                                    v-if="commodityList.orderStatus == '退款退货'"
                                    style="width:14%"
                                >{{item.productSaleStatus==1?(item.outputNum):0}}</div>
                            </div>
                        </div>
                        <div class="price alignCenter column">
                            <div>总数：{{commodityList.qrcBuyCount}}</div>
                            <div>合计：￥{{commodityList.gainMoney}}</div>
                        </div>
                        <div class="state alignCenter column">
                            <div style="margin-top:27px">{{commodityList.orderStatus}}</div>
                            <!-- <div>订货详情</div> -->
                        </div>
                        <div id="operate" class="operate justCenter">
                            <div style="margin-top:27px">
                                <el-button size="small" @click="open(commodityList)">备注</el-button>
                                <el-button
                                    size="small"
                                    v-if="commodityList.orderStatus != '关闭'"
                                    @click="print"
                                >打印小票</el-button>
                                <el-button
                                    v-if="commodityList.orderStatus == '退款退货'"
                                    size="small"
                                    type="primary"
                                    @click="treasury"
                                >退货入库</el-button>
                                <el-button
                                    v-if="commodityList.orderStatus == '完成'"
                                    size="small"
                                    type="primary"
                                    @click="refund(goodsList)"
                                >退款</el-button>
                            </div>
                        </div>
                    </div>
                    <div
                        class="bottom"
                        v-if="commodityList.orderMark || commodityList.refundRemark"
                    >
                        <div v-if="commodityList.orderMark">
                            商家备注：
                            <span style="color:red">{{commodityList.orderMark}}</span>
                        </div>
                        <div v-if="commodityList.refundRemark">
                            退款备注：
                            <span style="color:red">{{commodityList.refundRemark}}</span>
                        </div>
                    </div>
                    <!-- //分页 -->
                    <!-- <div class="block" style="float:right;margin-top:10px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage4"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="goodsList.totalCount"
            ></el-pagination>
                    </div>-->
                </div>
            </div>
        </div>
        <!-- <img id="barcode" style="display:none" /> -->
        <canvas id="canvas" style="width:100px;height:100px;display:none;"></canvas>
    </div>
</template>
<script>
import JsBarcode from "jsbarcode";
import QRCode from "qrcode";
import { toRefundOrderDetail } from "../api";
export default {
  name: "orderManagement",

  data() {
      return {
          currentPage4: 1, //页数
          commodityList: [],
          userList: "", //用户信息
          shopInformation: "", //店铺信息
          goodsList: [], //商品列表
          type: "default",
          orderList: [],
          toRefundOrderDetail: [],
          settlementMethod: "",
          qrcodeUrl: "",
          money: 0,
          loading: false
      };
  },

  created() {
      let userList = JSON.parse(this.getCookie("userList"));
      let shopInformation = JSON.parse(this.getCookie("shopInformation"));
      this.userList = userList;
      this.shopInformation = shopInformation;
      // 订单列表
      var id = this.$route.query.name;
      this.type = this.$route.query.type;

      console.log(id, "id");
      //商品列表
      this.request
          .post("qrcapi/MallOrder_mallOrderProductPager", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              mallOrderId: id,
              pageSize: 9999
          })
          .then(res => {
              // console.log(res, "商品列表哦");
              this.goodsList = res.data.pager;
              var goodsList = this.goodsList;
              var qrcBuyCount = 0;
              var retailPrice = 0;
              var totalDiscounts = 0;

              for (let j in goodsList.list) {
                  // console.log(goodsList.list[j].buyCount, "666");
                  qrcBuyCount += goodsList.list[j].qrcBuyCount;
                  retailPrice +=
                      // goodsList.list[j].retailPrice *
                      // goodsList.list[j].buyCount;
                      goodsList.list[j].totalTurnoverPrice;
                  totalDiscounts +=
                      (goodsList.list[j].retailPrice -
                          goodsList.list[j].turnoverPrice) *
                      goodsList.list[j].qrcBuyCount;
              }
              this.$set(this.goodsList, "totalCount", qrcBuyCount);
              this.$set(this.goodsList, "totalRetailPrice", retailPrice);
              this.$set(this.goodsList, "totalDiscounts", totalDiscounts);
              // console.log(this.goodsList, "123");
          });
  },

  mounted() {
      this.commodityList.push(this.$route.query.name);
      this.MallOrder_toManegerOrderDetail(this.$route.query.name);
      console.log(this.$route.query.tradeNo, "tradeNo");
      this.$nextTick(() => {
          this.useqrcode(this.$route.query.tradeNo);
      });
      // console.log(this.content, 12233)
      // QRCode.toDataURL(this.content,
      //   {errorCorrectionLevel: "Q", version: 3},
      //   function(err, url) {
      //     if (!err) {
      //       this.qrcodeUrl = url
      //     }
      //   }
      // )
  },

  methods: {
      useqrcode(qrCodeUrl) {
          this.QueryDetail = qrCodeUrl;
          console.log(this.QueryDetail, "this.QueryDetail");
          var canvas = document.getElementById("canvas");
          QRCode.toCanvas(canvas, this.QueryDetail, function(error) {
              if (error) console.error(error);
              var imgUrl = canvas.toDataURL("image/png");
              console.log(imgUrl, "imgUrl");
              localStorage.setItem("imgUrl", imgUrl);
          });
      },
      print() {
          var barCode = localStorage.getItem("imgUrl");
          // var barCode = this.barCode;

          if (
              this.commodityList.orderStatus == "退款退货" ||
              this.commodityList.orderStatus == "退款"
          ) {
              var orderList = this.toRefundOrderDetail;
              console.log(orderList, "this.toRefundOrderDetail");
          } else {
              var orderList = this.commodityList;
              console.log(orderList, "this.commodityList");
          }
          if (!orderList) {
              this.$message.error("请等待页面加载");
              return;
          }
          // this.barCode = document.getElementById("barcode").src;
          console.log(barCode, "barCode");

          if (
              this.commodityList.orderStatus == "退款退货" ||
              this.commodityList.orderStatus == "退款"
          ) {
              //退款退货打印单模板  <img id="barcode" src="${barCode}" style="width:180px; transform: scale(0.5); object-fit: contain;" />
              var template_html = `
    <form id="from">
      <div class="center column">
        <div class="center shopName boldFont">${
            this.shopInformation.shopName
        }</div>
        <img id="barcode" src="${barCode}" style="width:80%;height:100px" />
      </div>
      <div class="content1">
        <div>退款单号：${orderList.orderCode}</div>
        <div>订单单号：${orderList.tradeNo}</div>
        <div>退款时间：${
            this.commodityList.orderStatus == "退款退货"
                ? orderList.createTime
                : ""
        }</div>
        <div>操作人员：${
            this.commodityList.orderStatus == "退款退货"
                ? orderList.refundOperator
                : ""
        }</div>
        <div class="br"></div>
      </div>
         <div>
      <div>
        <div class="flex-between">
          <div style="width:40%">品名</div>
          <div class="center" style="width:30%">退货数量</div>
          <div style="width:30%;text-align: right;">退款金额</div>
        </div>
   
    `;
              // var totalNum = 0;

              orderList.products.forEach(item => {
                  // totalNum += item.buyCount;
                  template_html += `
        <div class="flex-between item">
          <div class="column name" style="width:40%">
            <div class>${item.goodsName} ${
                      item.specDesc ? "(" + item.specDesc + ")" : ""
                  }</div>
          </div>
          <div class="justCenter" style="width:30%">${item.refundCount}</div>
          <div style="width:30%;text-align: right;">${item.refundMoney}</div>
        </div>
     `;
              });

              template_html += `
     </div>
      <div class="br"></div>
    </div>
    <div >
      <div class="flex-between">
        <div>总退货数：</div>
        <div>${orderList.refundCount}</div>
      </div>
      <div class="flex-between">
        <div>退款方式：</div>
        <div>${
            orderList.settlementMethod == 0
                ? "未知"
                : orderList.settlementMethod == 1
                ? "系统"
                : orderList.settlementMethod == 2
                ? "支付宝"
                : orderList.settlementMethod == 3
                ? "微信"
                : orderList.settlementMethod == 4
                ? "银联支付"
                : orderList.settlementMethod == 5
                ? "百付宝 "
                : orderList.settlementMethod == 6
                ? "QQ钱包 "
                : orderList.settlementMethod == 7
                ? "京东钱包 "
                : orderList.settlementMethod == 11
                ? "现金退款"
                : orderList.settlementMethod == 12
                ? "支付宝记账"
                : orderList.settlementMethod == 13
                ? "微信记账"
                : orderList.settlementMethod == 8
                ? "刷卡记账"
                : orderList.settlementMethod == 10
                ? "会员卡支付"
                : ""
        }</div>
      </div>
      <div class="flex-between">
        <div style="width: 35%">退款原因：</div>
        <div style="width: 65%; display: flex; flex-wrap: wrap;">${
            orderList.refundRemark
        }</div>
      </div>
      <div class="flex-between boldFont">
        <div  class="">总退金额：</div>
        <div>${orderList.refundMoney.toFixed(2)}</div>
      </div>
      <div class="br"></div>
    </div>
    <div>
      <div class="flex-between">
        <div>买家：</div>
         <div>${orderList.buyerName ? orderList.buyerName : "匿名用户"}</div>
      </div>
      <div class="br"></div>
    </div>
    <div>
      <div class>顾客签名：</div>
      <div class>店铺签名：</div>
      <div class="br"></div>
    </div>
    <div>
      <div class>店铺电话：${this.shopInformation.shopTel}</div>
      <div class>店铺地址：${this.shopInformation.shopAddress}</div>
    </div>
  </form>
     `;
          } else {
              //普通订单
              // console.log(orderList)
              var template_html = `
    <form id="from">
      <div class="center column">
        <div class="center shopName boldFont">${this.shopInformation.shopName}</div>
        <img id="barcode" src="${barCode}" style="width:80%;height:100px" />
      </div>
      <div class="content1">
        <div class="boldFont">流水号：${orderList.orderNum}</div>
        <div>单号：${orderList.tradeNo}</div>
        <div>时间：${orderList.payTime}</div>
        <div>收银：${orderList.cashierUserFullName}</div>
        <div class="br"></div>
      </div>
         <div>
      <div>品名</div>
      <div>
        <div class="flex-between">
          <div style="width:40%">单价</div>
          <div class="center" style="width:30%">数量</div>
          <div style="width:30%;text-align: right;">金额</div>
        </div>
   
    `;
              // var totalNum = 0;
              this.goodsList.list.forEach(item => {
                  // totalNum += item.qrcBuyCount;
                  template_html += `
        <div class="flex-between item">
          <div class="column name" style="width:40%">
            <div class>${item.goodsName} ${
                      item.specDesc ? "(" + item.specDesc + ")" : ""
                  }</div>
            <div>${
                item.discountPrice ? item.discountPrice : item.retailPrice
            }</div>
          </div>
          <div class="justCenter" style="width:30%">${item.qrcBuyCount}</div>
          <div style="width:30%;text-align: right;">${
              item.discountPrice ? item.discountPrice : item.retailPrice
          }</div>
        </div>
     `;
              });
              template_html += `
     </div>
      <div class="br"></div>
    </div>
    <div >
      <div class="flex-between">
        <div>总数：</div>
        <div>${orderList.qrcBuyCount}</div>
      </div>
      <div class="flex-between">
        <div>总价：</div>
        <div>${orderList.totalRetailPrice.toFixed(2)}</div>
      </div>`;
              if (orderList.shopPromotionData.length !== 0) {
                  template_html += `
          <div class="flex-between">
            <div class="width35">优惠方式：</div>
            <div class="width65">${orderList.shopPromotionData[0].name}</div>
          </div>
        `;
              }
              template_html += `
      <div class="flex-between">
        <div>优惠金额：</div>
        <div>${orderList.totalDiscountPrice.toFixed(2)}</div>
      </div>
      <div class="flex-between">
        <div>支付方式：</div>
        <div>${
            orderList.payInterfacePartyType == 0
                ? "未知"
                : orderList.payInterfacePartyType == 1
                ? "系统"
                : orderList.payInterfacePartyType == 2
                ? "支付宝"
                : orderList.payInterfacePartyType == 3
                ? "微信"
                : orderList.payInterfacePartyType == 11
                ? "线下收款"
                : orderList.payInterfacePartyType == 12
                ? "支付宝记账"
                : orderList.payInterfacePartyType == 13
                ? "微信记账"
                : orderList.payInterfacePartyType == 8
                ? "刷卡记账"
                : orderList.payInterfacePartyType == 10
                ? "会员卡支付"
                : ""
        }</div>
      </div>
      <div class="flex-between">
        <div>应付：</div>
        <div>${orderList.gainMoney.toFixed(2)}</div>
      </div>
      <div class="flex-between boldFont" >
        <div class="">实付：</div>
        <div>${
            orderList.giveChange
                ? (orderList.giveChange + orderList.gainMoney).toFixed(2)
                : orderList.gainMoney.toFixed(2)
        }</div>
      </div>`;
              if (orderList.payInterfacePartyType == 11) {
                  template_html += `
         <div class="flex-between boldFont" >
           <div  class="">找零：</div>
           <div>${
               orderList.giveChange
                   ? orderList.giveChange.toFixed(2)
                   : this.money.toFixed(2)
           }</div>
         </div>`;
              }
              template_html += `
      <div class="br"></div>
    </div>
    <div>
      <div class="flex-between">
        <div>会员信息：</div>
         <div>${orderList.buyerName ? orderList.buyerName : "匿名用户"}</div>
      </div>
      <div class="br"></div>
    </div>
    <div>
      <div class>顾客签名：</div>
      <div class>店铺签名：</div>
      <div class="br"></div>
    </div>
    <div>
      <div class>店铺电话：${this.shopInformation.shopTel}</div>
      <div class>店铺地址：${this.shopInformation.shopAddress}</div>
    </div>
  </form>
     `;
          }

          template_html += `<style>
   .item {
margin-top: 10px;
}
#from{
font-size: 12px;
padding-right:5px
}
.width35 {
width: 35%;
}
.width65 {
width: 65%;
text-align: right;
right: 0;
font-size: 10px;
}
.br{  
border-bottom: 1px dashed  #000;
margin: 10px 0;
}
.boldFont{
 font-size: 22px;
font-weight: 600;
}
.shopName{
margin-bottom:20px;

}
.center {
display: flex;
align-items: center;
justify-content: center;
}

.row {
display: flex;
flex-direction: row;
}

.column {
display: flex;
flex-direction: column;
}

.justCenter {
display: flex;
justify-content: center;
}

.alignCenter {
display: flex;
align-items: center;
}
.flex-between {
display: flex;
justify-content: space-between;
}</style>
`;

          LODOP.PRINT_INIT("订单小票");
          LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", template_html);
          // LODOP.ADD_PRINT_BARCODE(0,0,200,100,"39Extended","*977752750227424*");
          LODOP.SET_PRINT_PAGESIZE(3, 600, 40, "");
          // LODOP.PREVIEW(); //预览
          LODOP.PRINT(); //打印
      },
      treasury() {
          this.$router.push({
              path: "returnOfTheTreasury",
              query: {
                  refundOrderId: this.commodityList.refundOrderId,
                  mallOrderId: this.commodityList.mallOrderId,
                  type: this.type
              }
          });
      },
      refund(a) {
          // console.log(a, this.$route.query.name);
          this.$router.push({
              path: "orderRefund",
              query: { id: this.$route.query.name }
          });
      },
      // 跳转订单界面
      hrefOrder() {
          this.$router.push("/orderManagment");
      },
      hrefOrder(path, query) {
          this.$router.push({ path: path, query: { name: query } });
      },
      //分页选择每页多少条
      handleSizeChange(val) {
          // console.log(`每页 ${val} 条`);
      },
      //分页当前页
      handleCurrentChange(val) {
          // console.log(`当前页: ${val}`);
      },
      open(item) {
          var id = this.$route.query.name;
          this.$prompt("请输入备注", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              inputType: "textarea",
              inputValue: item.orderMark
          })
              .then(({ value }) => {
                  // item.content = value;

                  // this.$message({
                  //   type: 'success',
                  //   message: '你的邮箱是: ' + value
                  // });
                  this.request
                      .post("qrcapi/MallOrder_saveOrderMark", {
                          sessionId: this.userList.sessionId,
                          userId: this.userList.id,
                          mallOrderId: id, //订单id
                          orderMark: value //备注
                      })
                      .then(res => {
                          // console.log(res, "添加备注");
                          if (res.code == 1) {
                              this.$message({
                                  type: "success",
                                  message: res.msg
                              });
                              this.commodityList.orderMark = value;
                              // this.MallOrder_mallOrdersForManager(); //订单列表
                          } else if (res.code == 2) {
                              this.$message.error(res.msg);
                              this.$router.push("/");
                          } else {
                              this.$message.error(res.msg);
                          }
                      });
              })
              .catch(() => {
                  this.$message({
                      type: "info",
                      message: "取消输入"
                  });
              });
      },
      MallOrder_toRefundOrderDetail(refundOrderId) {
          this.loading = true;
          toRefundOrderDetail({
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              refundOrderId: refundOrderId,
              isNeedGoods: 0
          })
              .then(res => {
                  // console.log(res.data, "toRefundOrderDetail");
                  this.toRefundOrderDetail = res.data;
                  if (res.code == 1) {
                      this.loading = false;
                  } else if (res.code == 2) {
                      this.$message.error(res.msg);
                      this.$router.push("/");
                  } else {
                  }
              })
              .catch(function(error) {});
      },
      MallOrder_toManegerOrderDetail(mallOrderId) {
          this.loading = true;
          //订单详情列表
          this.request
              .post("qrcapi/MallOrder_toManegerOrderDetail", {
                  sessionId: this.userList.sessionId,
                  userId: this.userList.id,
                  mallOrderId: mallOrderId
              })
              .then(res => {
                  // console.log(res, "订单详情列表");
                  if (res.code == 1) {
                      // this.$message({
                      //   message: res.msg,
                      //   type: "success"
                      // });
                      this.commodityList = res.data;
                      console.log(this.commodityList, "订单详情列表");
                      localStorage.setItem(
                          "payInterfacePartyType",
                          this.commodityList.payInterfacePartyType
                      );
                      this.commodityList.shopPromotionData = JSON.parse(
                          this.commodityList.shopPromotionData
                      );
                      this.MallOrder_toRefundOrderDetail(
                          res.data.refundOrderId
                      );
                      this.loading = false;
                      switch (this.commodityList.orderStatus) {
                          case 10:
                              this.commodityList.orderStatus = "未付款";
                              break;
                          case 20:
                              this.commodityList.orderStatus = "等待发货";
                              break;
                          case 30:
                              this.commodityList.orderStatus = "等待确认收货";
                              break;
                          case 40:
                              this.commodityList.orderStatus = "完成";
                              break;
                          case -10:
                              this.commodityList.orderStatus = "关闭";
                              break;
                          case -20:
                              this.commodityList.orderStatus = "取消";
                              break;
                          case -21:
                              this.commodityList.orderStatus = "申请退款";
                              break;
                          case -25:
                              this.commodityList.orderStatus = "退款中";
                              break;
                          case -50:
                              this.commodityList.orderStatus = "退款";
                              break;
                          case -51:
                              this.commodityList.orderStatus = "退款退货";
                              break;
                      }
                      var qrcBuyCount = 0;
                      var retailPrice = 0;
                      var totalDiscounts = 0;

                      for (let j in this.commodityList.products) {
                          qrcBuyCount += this.commodityList.products[j]
                              .qrcBuyCount;
                          retailPrice +=
                              // this.commodityList.products[j].retailPrice *
                              // this.commodityList.products[j].buyCount;
                              this.commodityList.products[j]
                                  .totalTurnoverPrice;
                          totalDiscounts +=
                              (this.commodityList.products[j].retailPrice -
                                  this.commodityList.products[j]
                                      .turnoverPrice) *
                              this.commodityList.products[j].qrcBuyCount;
                      }
                      this.$set(
                          this.commodityList,
                          "totalCount",
                          qrcBuyCount
                      );
                      // this.$set(this.commodityList, "totalRetailPrice", retailPrice);
                      this.$set(
                          this.commodityList,
                          "totalDiscounts",
                          totalDiscounts
                      );
                      // JsBarcode("#barcode", this.commodityList.tradeNo, {
                      //   // displayValue: false,
                      //   format: "CODE128",//选择要使用的条形码类型
                      //   displayValue: true,//是否在条形码下方显示文字
                      //   textPosition: "top"//设置文本的垂直位置
                      // });
                      // JsBarcode("#barcode", this.commodityList.tradeNo)
                      // this.barCode = document.getElementById("barcode").src;
                      // console.log(document.getElementById("barcode").src, "barCode");
                      // console.log(this.commodityList, "11");
                  } else if (res.code == 2) {
                      this.$message.error(res.msg);
                      this.$router.push("/");
                  } else {
                      this.$message.error(res.msg);
                  }
              });
      }
  }
};
</script>

<style>
     .item {
  margin-top: 10px;
}
#from{
  font-size: 12px;
  padding-right:5px
}
.width35 {
  width: 35%;
}
.width65 {
  width: 65%;
  text-align: right;
  right: 0;
  font-size: 10px;
}
.br{  
  border-bottom: 1px dashed  #000;
  margin: 10px 0;
}
.boldFont{
   font-size: 22px;
  font-weight: 600;
}
.shopName{
  margin-bottom:20px;
 
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}

.justCenter {
  display: flex;
  justify-content: center;
}

.alignCenter {
  display: flex;
  align-items: center;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}</style>
`;

            LODOP.PRINT_INIT("订单小票");
            LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", template_html);
            // LODOP.ADD_PRINT_BARCODE(0,0,200,100,"39Extended","*977752750227424*");
            LODOP.SET_PRINT_PAGESIZE(3, 600, 40, "");
            // LODOP.PREVIEW(); //预览
            LODOP.PRINT(); //打印
        },
        treasury() {
            this.$router.push({
                path: "returnOfTheTreasury",
                query: {
                    refundOrderId: this.commodityList.refundOrderId,
                    mallOrderId: this.commodityList.mallOrderId,
                    type: this.type
                }
            });
        },
        refund(a) {
            // console.log(a, this.$route.query.name);
            this.$router.push({
                path: "orderRefund",
                query: { id: this.$route.query.name }
            });
        },
        // 跳转订单界面
        hrefOrder() {
            this.$router.push("/orderManagment");
        },
        hrefOrder(path, query) {
            this.$router.push({ path: path, query: { name: query } });
        },
        //分页选择每页多少条
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
        },
        //分页当前页
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
        },
        open(item) {
            var id = this.$route.query.name;
            this.$prompt("请输入备注", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputType: "textarea",
                inputValue: item.orderMark
            })
                .then(({ value }) => {
                    // item.content = value;

                    // this.$message({
                    //   type: 'success',
                    //   message: '你的邮箱是: ' + value
                    // });
                    this.request
                        .post("qrcapi/MallOrder_saveOrderMark", {
                            sessionId: this.userList.sessionId,
                            userId: this.userList.id,
                            mallOrderId: id, //订单id
                            orderMark: value //备注
                        })
                        .then(res => {
                            // console.log(res, "添加备注");
                            if (res.code == 1) {
                                this.$message({
                                    type: "success",
                                    message: res.msg
                                });
                                this.commodityList.orderMark = value;
                                // this.MallOrder_mallOrdersForManager(); //订单列表
                            } else if (res.code == 2) {
                                this.$message.error(res.msg);
                                this.$router.push("/");
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "取消输入"
                    });
                });
        },
        MallOrder_toRefundOrderDetail(refundOrderId) {
            this.loading = true;
            toRefundOrderDetail({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                refundOrderId: refundOrderId,
                isNeedGoods: 0
            })
                .then(res => {
                    // console.log(res.data, "toRefundOrderDetail");
                    this.toRefundOrderDetail = res.data;
                    if (res.code == 1) {
                        this.loading = false;
                    } else if (res.code == 2) {
                        this.$message.error(res.msg);
                        this.$router.push("/");
                    } else {
                    }
                })
                .catch(function(error) {});
        },
        MallOrder_toManegerOrderDetail(mallOrderId) {
            this.loading = true;
            //订单详情列表
            this.request
                .post("qrcapi/MallOrder_toManegerOrderDetail", {
                    sessionId: this.userList.sessionId,
                    userId: this.userList.id,
                    mallOrderId: mallOrderId
                })
                .then(res => {
                    // console.log(res, "订单详情列表");
                    if (res.code == 1) {
                        // this.$message({
                        //   message: res.msg,
                        //   type: "success"
                        // });
                        this.commodityList = res.data;
                        console.log(this.commodityList, "订单详情列表");
                        localStorage.setItem(
                            "payInterfacePartyType",
                            this.commodityList.payInterfacePartyType
                        );
                        this.commodityList.shopPromotionData = JSON.parse(
                            this.commodityList.shopPromotionData
                        );
                        this.MallOrder_toRefundOrderDetail(
                            res.data.refundOrderId
                        );
                        this.loading = false;
                        switch (this.commodityList.orderStatus) {
                            case 10:
                                this.commodityList.orderStatus = "未付款";
                                break;
                            case 20:
                                this.commodityList.orderStatus = "等待发货";
                                break;
                            case 30:
                                this.commodityList.orderStatus = "等待确认收货";
                                break;
                            case 40:
                                this.commodityList.orderStatus = "完成";
                                break;
                            case -10:
                                this.commodityList.orderStatus = "关闭";
                                break;
                            case -20:
                                this.commodityList.orderStatus = "取消";
                                break;
                            case -21:
                                this.commodityList.orderStatus = "申请退款";
                                break;
                            case -25:
                                this.commodityList.orderStatus = "退款中";
                                break;
                            case -50:
                                this.commodityList.orderStatus = "退款";
                                break;
                            case -51:
                                this.commodityList.orderStatus = "退款退货";
                                break;
                        }
                        var qrcBuyCount = 0;
                        var retailPrice = 0;
                        var totalDiscounts = 0;

                        for (let j in this.commodityList.products) {
                            qrcBuyCount += this.commodityList.products[j]
                                .qrcBuyCount;
                            retailPrice +=
                                // this.commodityList.products[j].retailPrice *
                                // this.commodityList.products[j].buyCount;
                                this.commodityList.products[j]
                                    .totalTurnoverPrice;
                            totalDiscounts +=
                                (this.commodityList.products[j].retailPrice -
                                    this.commodityList.products[j]
                                        .turnoverPrice) *
                                this.commodityList.products[j].qrcBuyCount;
                        }
                        this.$set(
                            this.commodityList,
                            "totalCount",
                            qrcBuyCount
                        );
                        // this.$set(this.commodityList, "totalRetailPrice", retailPrice);
                        this.$set(
                            this.commodityList,
                            "totalDiscounts",
                            totalDiscounts
                        );
                        // JsBarcode("#barcode", this.commodityList.tradeNo, {
                        //   // displayValue: false,
                        //   format: "CODE128",//选择要使用的条形码类型
                        //   displayValue: true,//是否在条形码下方显示文字
                        //   textPosition: "top"//设置文本的垂直位置
                        // });
                        // JsBarcode("#barcode", this.commodityList.tradeNo)
                        // this.barCode = document.getElementById("barcode").src;
                        // console.log(document.getElementById("barcode").src, "barCode");
                        // console.log(this.commodityList, "11");
                    } else if (res.code == 2) {
                        this.$message.error(res.msg);
                        this.$router.push("/");
                    } else {
                        this.$message.error(res.msg);
                    }
                });
        }
    },
    created() {
        let userList = JSON.parse(this.getCookie("userList"));
        let shopInformation = JSON.parse(this.getCookie("shopInformation"));
        this.userList = userList;
        this.shopInformation = shopInformation;
        // 订单列表
        var id = this.$route.query.name;
        this.type = this.$route.query.type;

        console.log(id, "id");
        //商品列表
        this.request
            .post("qrcapi/MallOrder_mallOrderProductPager", {
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                mallOrderId: id,
                pageSize: 9999
            })
            .then(res => {
                // console.log(res, "商品列表哦");
                this.goodsList = res.data.pager;
                var goodsList = this.goodsList;
                var qrcBuyCount = 0;
                var retailPrice = 0;
                var totalDiscounts = 0;

                for (let j in goodsList.list) {
                    // console.log(goodsList.list[j].buyCount, "666");
                    qrcBuyCount += goodsList.list[j].qrcBuyCount;
                    retailPrice +=
                        // goodsList.list[j].retailPrice *
                        // goodsList.list[j].buyCount;
                        goodsList.list[j].totalTurnoverPrice;
                    totalDiscounts +=
                        (goodsList.list[j].retailPrice -
                            goodsList.list[j].turnoverPrice) *
                        goodsList.list[j].qrcBuyCount;
                }
                this.$set(this.goodsList, "totalCount", qrcBuyCount);
                this.$set(this.goodsList, "totalRetailPrice", retailPrice);
                this.$set(this.goodsList, "totalDiscounts", totalDiscounts);
                // console.log(this.goodsList, "123");
            });
    },
    mounted() {
        this.commodityList.push(this.$route.query.name);
        this.MallOrder_toManegerOrderDetail(this.$route.query.name);
        console.log(this.$route.query.tradeNo, "tradeNo");
        this.$nextTick(() => {
            this.useqrcode(this.$route.query.tradeNo);
        });
        // console.log(this.content, 12233)
        // QRCode.toDataURL(this.content,
        //   {errorCorrectionLevel: "Q", version: 3},
        //   function(err, url) {
        //     if (!err) {
        //       this.qrcodeUrl = url
        //     }
        //   }
        // )
    }
};
</script>
<style scoped>
#canvas {
    width: 15% !important;
    height: auto !important;
}
.head {
    box-sizing: border-box;
    padding: 14px 25px;
    background: #f8f8f8;
    width: 100%;
    padding-top: 64px;
}
.content {
  box-sizing: border-box;
  background: #fff;
  height: calc(100vh - 210px);
  /* width: 100%; */
  width: calc(100vw - 250px);
  padding: 30px 25px;
}
.table {
    width: 99.9%;
    border: 1px solid #e4e7ed;
    margin-top: 20px;
    font-size: 12px;
}
.tables {
    max-height: 550px;
    overflow-y: scroll;
}
.tableHead {
    background: #f8f8f8;
    width: 100%;
    border-bottom: 1px solid #e4e7ed;
    color: gray;
    line-height: 40px;
}
.tableHead2 {
    background: #f8f8f8;
    width: 100%;
    border-bottom: 1px solid #e4e7ed;
    color: gray;
    line-height: 40px;
}
.tableHead div {
    margin-left: 20px;
}
.commodityList {
    width: 100%;
}
.price {
    width: 12%;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
}
.total {
    width: 100%;
}
.portion {
    width: 25%;
    border-right: 1px solid #e4e7ed;
    font-size: 14px;
    padding-bottom: 20px;
}
.portion div {
    margin-left: 70px;
}
.portion div:first-child {
    margin-top: 40px;
}
.price div:last-child {
    margin-bottom: 15px;
}
.portion div:not(:first-child) {
    margin-top: 5px;
    color: #858585;
}
.portion:last-child {
    border: none;
}
.price div,
.state div {
    margin-top: 15px;
}
.state {
    width: 12%;
    border-right: 1px solid #e4e7ed;
}
.operate {
    width: 18%;
}
.commodity {
    width: 58%;
}
.commodity img {
    width: 63px;
    height: 63px;
}
.commodityItem:not(:last-child) {
    border-bottom: 1px solid #e4e7ed;
}
.commodityItem {
    height: 110px;
    font-size: 12px;
}
.toto {
    width: 58%;
    margin: 0 !important;
}
.toto div {
    margin: 0;
}

.bottom {
    padding: 19px;
    border-top: 1px solid #e4e7ed;
    font-size: 12px;
}
.tableHead {
    margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/orderDetails.vue